export default class GetUserAbsencesRequest {
    public userId: string = "";
    public from?: Date | null;
    public to?: Date | null;
}
